export default __webpack_public_path__ + "static/media/2.93dfd419.jpg";